var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"layout/flex layout/flex:grow layout/height:100%"},[_c('button',{staticClass:"@768/layout/padding:left @768/layout/padding:right $color/black color/background layout/align:center layout/border:3pt layout/flex layout/flex:grow layout/height:100% layout/justify:center layout/padding:left:clear layout/padding:right:clear link/cursor",class:[
      this.backgroundColor,
      `${_vm.floor !== '6' ? 'layout/border:right:clear' : ''}`
    ],staticStyle:{"--768--layout--padding--left":"16px","--768--layout--padding--right":"16px"},on:{"click":function($event){return _vm.handleFloorSelection(_vm.floor)}}},[_c('p',{class:[
        this.textColor,
        'typography'
      ]},[_vm._v("\n      "+_vm._s(_vm.floor)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }